import { render, staticRenderFns } from "./MediaLibraryFolder.vue?vue&type=template&id=606c8296&scoped=true&"
import script from "./MediaLibraryFolder.vue?vue&type=script&lang=js&"
export * from "./MediaLibraryFolder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606c8296",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\marketingdatabase-git\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('606c8296')) {
      api.createRecord('606c8296', component.options)
    } else {
      api.reload('606c8296', component.options)
    }
    module.hot.accept("./MediaLibraryFolder.vue?vue&type=template&id=606c8296&scoped=true&", function () {
      api.rerender('606c8296', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/MediaLibrary/Components/MediaLibraryFolder.vue"
export default component.exports